import React from "react";
import HeaderSection from "../HeaderSection";
import Slider from "react-slick";
import { data } from "./data";
import styles from "./style.module.scss";
import { Link } from "react-router-dom";
import { IoIosLink } from "react-icons/io";

const LatestWork = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.5,
    slidesToScroll: 4.5,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 2.2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 2.2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <HeaderSection
        title={"Latest Work"}
        link={"/portfolio"}
        link_name={"Browse Portfolio"}
      />
      <div className="slider-container">
        <Slider {...settings}>
          {data.map((el) => (
            <div className={styles.card} key={el.id}>
              <div className={styles.title}>

              <h1>{el.title}</h1>
              <h5>{el.description}</h5>
              </div>
              <div className={styles.image}>
                <img src={el.image} alt={el.title} />
                <Link to={el.link} target="_blank">
                  <IoIosLink /> <span>Visit Website</span>
                </Link>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default LatestWork;
